import { useCallback } from 'react';
import writeXlsxFile, { SheetData } from 'write-excel-file';
import { $TSFixMe } from 'src/interface';

export type XlsxTableConfig<T> = {
  title: string;
  field: string;
  key: string;
  render?: (
    value: $TSFixMe,
    record: T,
    index: number,
  ) => string | number | boolean;
  summaryRender?: (
    value: $TSFixMe,
    record: T,
    index: number,
  ) => string | number | boolean;
};

type XlsxTableProps<T> = {
  config: XlsxTableConfig<T>[];
  data: T[];
  summaryRecord?: T;
};

export function useXlsxWriter<RecordType extends object = $TSFixMe>() {
  const writeToXlsx = useCallback(
    (
      params: XlsxTableProps<RecordType>,
      fileName: string,
      dataOnly?: boolean,
    ) => {
      const { config, data, summaryRecord } = params;

      const sheetData: SheetData = data.map((record) =>
        config.map(({ field, render }, index) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          const value = record[field];

          return {
            value: render?.(value, record, index) || value,
            fontFamily: 'Calibri',
            fontSize: 12,
          };
        }),
      );

      if (summaryRecord) {
        sheetData.unshift(
          config.map(({ field, render, summaryRender }, index) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            const value = summaryRecord[field];

            return {
              value:
                summaryRender?.(value, summaryRecord, index) ||
                render?.(value, summaryRecord, index) ||
                value,
              fontFamily: 'Calibri',
              fontWeight: 'bold',
              fontStyle: 'italic',
              fontSize: 12,
            };
          }),
        );
      }

      if (!dataOnly) {
        sheetData.unshift(
          config.map(({ title }) => ({
            value: title.replaceAll('\n', ' '),
            fontWeight: 'bold',
            fontFamily: 'Calibri',
            fontSize: 13,
          })),
        );
      }

      writeXlsxFile(sheetData, {
        fileName,
      });
    },
    [],
  );

  return {
    writeToXlsx,
  };
}
